import Textarea from '@mui/joy/Textarea';
import { useState, useEffect, useContext } from 'react';
import OfferPopover from '../offer/OfferPopover';
import { useForm } from 'react-hook-form';
import CustomInput from '../inputs/CustomInput';
import MainContext from '../../context/MainContext';
import Loader from '../Loader';
import Select from 'react-select';
import { title } from 'process';
import { Checkbox } from '@mui/material';
import CustomModal from '../modals/CustomModal';
import SimpleImageSlider from 'react-simple-image-slider';
import { apiURL } from '../../consts/URLs';



const FastEditRow = (props: any) => {

    const fastEditForm = useForm();
    const [updated, setUpdated] = useState<boolean>(false);
    const { token, refresh } = useContext(MainContext);
    const [loading, setLoading] = useState<boolean>(false);
    const [published, setPublished] = useState<number>(0);
    const [title, setTitle] = useState<any>();
    const [categories, setCategories] = useState<{value:number,label:string}[]>([]);
    const [selectedCategory, setSelectedCategory]= useState<{value:number,label:string}>();

    const handleChangePublished = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPublished(event.target.checked ? 1 : 0);
    };

    const handleChangeCategory= (selected : any) => {
        fastEditForm.setValue('categoryId', selected.value);
        setSelectedCategory(selected);
    }

    const CustomStyle = {
        option: (base: any, state:any) => ({
          ...base,
          backgroundColor: state.isSelected ? 'green' : 'white',
          width:'150px',
        }),
        control: (base: any) => ({
            ...base,
            width: "max-content",
            minWidth: "100%"
       }),
       menu: (base: any) => ({
        ...base,
        width: "max-content",
        minWidth: "100%",
        padding: 0,
        margin: 0
   }),
    }

    const onFastEdit = async (obj: any) => {
        if (!(published === 1 && obj.quantity <= 0)) {

            if (isNaN(obj.quantity)) {
                alert("ERRORE: la quantità inserita non ha un valore valido!");
            }else if (isNaN(obj.waist)) {
                alert("ERRORE: il peso inserito non ha un valore valido!");
            } else if (isNaN(obj.final_price)) {
                alert("ERRORE: il prezzo inserito non ha un valore valido!");
            } else {
                setLoading(true);
                const condition = obj.conditionId && obj.conditionId !== undefined && obj.conditionId !== 'undefined' && obj.conditionId !== null ? "&condition_id=" + obj.conditionId : '';
                const category = obj.categoryId && obj.categoryId !== undefined && obj.categoryId !== 'undefined' && obj.categoryId !== null ? "&category_id=" + obj.categoryId : '';
                const endpoint = `${apiURL}/products/${obj.SKU}?title=${title}&quantity=${obj.quantity}&waist=${obj.waist}&final_price=${obj.final_price}&published=${published ? 1 : 0}${condition}${category}`;

                /**
                 * GIANLUCA BIANCHI: ENABLE ONLY FOR DEV TESTING, NO PROD ENABLED
                 */
                //alert(endpoint);
                const header = {
                    method: 'PUT',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                };
                const response = await fetch(endpoint, header);
                if (response.ok) {
                    setUpdated(true);
                } else {
                    alert("errore:" + (await response.text()).toString());
                }

                setLoading(false);
            }


        } else {
            alert("Non puoi pubblicare un prodotto con quantità <= 0!");
            setPublished(0);
        }


    }

    useEffect(()=>{
        fastEditForm.setValue('SKU', props.offer.SKU);
        setPublished(props.offer.published ? 1 : 0);
        setTitle(props.offer.title);
        fastEditForm.setValue('category_id', props.offer.category?.id);
        setSelectedCategory({value:props.offer.category?.id, label:props.offer.category?.name});
        setCategories(props.categories.map((cat: { id: number; name: string; }) => ({value:cat.id,label:cat.name})));
    },[]);


    return (
        
            <form className={"form-inline"} name="fastEditForm" onSubmit={fastEditForm.handleSubmit(onFastEdit)}>
                   <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '20px 0px'}}>
                   
                <div className='product-card' style={{backgroundColor: updated ? 'green' :'' }}>
                    {
                        loading ?

                        <Loader />

                        :

                        <div></div>
                    }
                      <button className='modal-button' style={{ marginLeft: 20, marginRight: 'auto', marginBottom: 0 }} type="submit">
                                <p className='add-buttonText'>Save</p>
                    </button>
                 
                <div style={{width:'100%'}}><Textarea onChange={(ev)=> setTitle(ev.target.value)}  maxRows={10} name="title" value={title} /></div>
                
                
                    <Select
                        name={'category_id'}
                        options={categories}
                        value={selectedCategory}
                        required={false}
                        isSearchable={true}
                        styles={CustomStyle}
                        onChange={handleChangeCategory}
                    />
                

                {props.offer.pictures[0] ? <img style={{ width: 80, height: 80 }} src={props.offer.pictures[0].url} onClick={()=>{props.setPopupImages(true);props.setDetailedImages(props.offer.pictures);}} /> : <div style={{ width: 80, height: 80 }} />}
                <CustomInput
                    title='prezzo'
                    name='final_price'
                    width={80}
                    type='text'
                    register={fastEditForm.register}
                    errors={fastEditForm.formState.errors}
                    defaultValue={props.offer.final_price}
                />
                <CustomInput
                    title='peso'
                    name='waist'
                    width={80}
                    type='text'
                    register={fastEditForm.register}
                    errors={fastEditForm.formState.errors}
                    defaultValue={props.offer.waist}
                />
                <CustomInput                     
                    title='quantità'
                    name='quantity'
                    width={80}
                    type='text'
                    register={fastEditForm.register}
                    errors={fastEditForm.formState.errors}
                    defaultValue={props.offer.quantity}
                />
                <CustomInput
                    title='condizione'
                    name='conditionId'
                    width={150}
                    type='select'
                    options={props.conditions}
                    register={fastEditForm.register}
                    errors={fastEditForm.formState.errors}
                    defaultValue={props.offer.condition.id}
                    idValue={true}
                />
                <Checkbox disabled={(props.offer.published===1) ? true :false} title='published' name='published' style={{height:'120px'}} checked={published===1 ? true : false} onChange={handleChangePublished} />
                <p>{props.offer.id}</p>
                
                </div>
                </div>
            </form>
      
    );
};

export default FastEditRow;